/**
 * 管理后台环境：只改下面常量即可（不必再改 config-dev / config-test / config-prod，也不必依赖 NODE_ENV）。
 * ENV 与 API 环境保持一致，用于本地缓存等。
 */

// --- 主接口（不要末尾 /）---
const API_HOST = 'https://sc-api.chengyingshengwu.com'   
// const API_HOST = 'https://sc-api-test.chengyingshengwu.com'
// const API_HOST = 'http://127.0.0.1:9002' 
// 

// --- dev | test | prod，建议与上面 API 环境一致 ---
const ENV = 'prod'
// const ENV = 'test'
// const ENV = 'dev'

const Conf = {
  ENV,
  API_HOST,
  HOST: '',
  APP_ID: ''
}

export default Conf
